import { string } from "yup";
import axios from "axios";
import Utilisateur from "../Models/Utilisateur";
import { apiEndpoints } from "../config";
import { Crypter } from "../Functions/Security/Crypter";
import Hash from "../Functions/Security/Hash";
import Agence from "../Models/Agence";
import * as React from "react";
//import { Crypter } from '../Functions/Security/Crypter';
import { useAuthHeader, useSignOut } from "../Services/Auth/sessionAuth";
import { useNavigate } from "react-router-dom";
//import SweetAlert from '../Functions/Traitement/SweetAlert';
import SweetAlert from "sweetalert2";
import { useState } from "react";
//const authHeader = useAuthHeader()
import Data from "../Data/Data.json";
import ParamsPicklist from "../Types/ParamsPicklist";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
//import "jspdf-autotable"
import autoTable from "jspdf-autotable"; // ✅ important
import {
  Document,
  Packer,
  Paragraph,
  Table,
  TableCell,
  TableRow,
  WidthType,
  TextRun,
} from "docx";
import { SimulationQardDto } from "../Models/SimulationQardDto";
import SimulationIjaraDto from "../Models/SimulationIjarahDto";
import DemandeIjaraDto from "../Models/DemandeIjarahDto";

// export interface SimulationQardDto {
//   codeSimul?: string | null;
//   typeQard: string;
//   montant: number;
//   nombreEch: number;
//   periodicite: string;
//   indice?: string | number | null;
//   frais?: number;
//   datePremEch: Date | string;
// }

export const PrintTabamountDemandeIjara = async (
  codUser: string,
  // Vos 10 paramètres d'en-tête requis
  CodAgce2: string,
  Libelle: string,
  Banque: string,
  Teleph: string,
  NumReg: string,
  Licence: string,
  NumCon: string,
  BPoste: string,
  Ville: string,
  NomUser: string,
  // LibellePeriodicite: string,
  NumeroDemande:string | undefined,
  // Les données de demande (Ijara)

  format: string = "pdf",
) => {
  try {
    // 1. Déclenchement du chargement avant la requête
    SweetAlert.fire({
      title: "Génération en cours",
      html: "Veuillez patienter pendant le chargement du tableau d'amortissement...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        SweetAlert.showLoading();
      }
    });

    // Formatage de la date au format YYYY-MM-DD pour l'API C#
    // const formattedDatePremEch = simulation.DatePremEch instanceof Date 
    //   ? simulation.DatePremEch.toISOString().split('T')[0] 
    //   : simulation.DatePremEch;
    

    const response = await axios.get(
      Data.ApiUrl.RapportTabamortIjarah,
      {
        params: {
          // Paramètres de calcul
          // Vos 10 paramètres d'en-tête pour le TableauAmont.frx
          codAgce2: CodAgce2,
          libelle: Libelle,
          banque: Banque,
          teleph: Teleph,
          numReg: NumReg,
          licence: Licence,
          numCon: NumCon,
          bPoste: BPoste,
          ville: Ville,
          nomUser: NomUser,
          // libperiodicite: LibellePeriodicite,
          NumeroDemande: NumeroDemande,
          format,
        },
        responseType: "blob",
      },
    );

    // 2. Fermeture du chargement une fois la réponse reçue
    SweetAlert.close();

    if (response.data) {
      const blob = new Blob([response.data], { type: "application/pdf" });
      const now = new Date();
      const formattedDate = now.toLocaleDateString("fr-FR").replace(/\//g, "-");
      const formattedTime = now.toLocaleTimeString("fr-FR").replace(/:/g, "-");
      
      // Nommage ciblé sur la simulation de Qard
      const fileName = `SimulationIjara_$${codUser}_${formattedDate}_${formattedTime}.${format}`;

      const url = window.URL.createObjectURL(blob);

      SweetAlert.fire({
        title: "Simulation générée",
        text: "Souhaitez-vous prévisualiser, imprimer ou télécharger le tableau d'amortissement ?",
        icon: "question",
        showCancelButton: true,
        showDenyButton: true,
        denyButtonText: "Imprimer",
        confirmButtonText: "Prévisualiser",
        cancelButtonText: "Télécharger",
      }).then((result) => {
        const file = new File([blob], fileName, { type: "application/pdf" });
        const fileUrl = URL.createObjectURL(file);

        if (result.isConfirmed) {
          // ✅ Prévisualiser
          window.open(fileUrl, "_blank");
        } else if (result.isDenied) {
          // ✅ Imprimer directement via le hack iframe
          const printHtml = `
            <html>
              <head>
                <title>${fileName}</title>
                <style>
                  html, body { margin: 0; height: 100%; }
                  iframe { width: 100%; height: 100%; border: none; }
                </style>
              </head>
              <body>
                <iframe id="pdfFrame" src="${fileUrl}"></iframe>
                <script>
                  const iframe = document.getElementById('pdfFrame');
                  iframe.onload = function() {
                    setTimeout(() => {
                      iframe.contentWindow.focus();
                      iframe.contentWindow.print();
                    }, 500);
                  };
                </script>
              </body>
            </html>
          `;
          const printBlob = new Blob([printHtml], { type: "text/html" });
          const printUrl = URL.createObjectURL(printBlob);
          window.open(printUrl, "_blank");
        } else {
          // ✅ Télécharger
          const link = document.createElement("a");
          link.href = fileUrl;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }

        // Nettoyage propre de la mémoire
        setTimeout(() => {
          URL.revokeObjectURL(fileUrl);
          URL.revokeObjectURL(url);
        }, 10000);
      });
    } else {
      SweetAlert.fire({
        title: "Erreur",
        text: "Erreur lors de la récupération du fichier de simulation.",
        icon: "error",
      });
    }
  } catch (error) {
    // 3. Fermeture automatique du chargement en cas de plantage réseau
    SweetAlert.close();
    console.error("Erreur lors de la génération du PDF :", error);
    SweetAlert.fire({ title: "Erreur", text: String(error), icon: "error" });
  }
};